import { Card } from "./card";

export function EmptyState({ title, body }: { title: string; body: string }) {
  return (
    <Card className="p-8 text-center">
      <h2 className="mb-4 text-xl">{title}</h2>
      <p className="mb-4">{body}</p>
    </Card>
  );
}
